import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import {
  BACKEND_EDUCATION_LIST_KEY,
  BACKEND_EDUCATION_GOAL_API,
} from '../ChildrenInfoWorkflowConstants';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import { isSpecificSchoolValidator } from '../ChildrenInfoWorkflowValidator';
import YesOrNoCheckbox from '../../YesOrNoCheckbox/YesOrNoCheckboxView';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';

const IsSpecificSchoolView = ({
  workflowId,
  branch,
  clientId,
  store,
  educationGoal,
  onPostProcess,
  nextIterators,
}) => (
  <AdvWorkflowStep branch={branch} workflowId={workflowId} id="IsSpecificCollege">
    <Validation
      workflowId={workflowId}
      validationId={`${BACKEND_EDUCATION_LIST_KEY}.IsSpecificCollege`}
    />

    <h2>Are you planning for a specific college?</h2>

    <YesOrNoCheckbox
      checked={educationGoal.IsSpecificCollege}
      onClick={({ target: { checked } }) => {
        store(workflowId)(
          {
            [BACKEND_EDUCATION_LIST_KEY]: {
              IsSpecificCollege: checked,
            },
          },
          clientId,
        );

        if (checked) {
          store(workflowId)(
            {
              [BACKEND_EDUCATION_LIST_KEY]: {
                SpecificCollegeName: '',
              },
            },
            clientId,
          );
        }
      }}
    />

    <Navigation
      nextIterators={nextIterators}
      dirtyGraphNodes={[]}
      validator={isSpecificSchoolValidator(educationGoal.IsSpecificCollege)}
      validationId={`${BACKEND_EDUCATION_LIST_KEY}.IsSpecificCollege`}
      workflowId={workflowId}
      backendKey={BACKEND_EDUCATION_GOAL_API}
      doNotSave
      onPostProcess={data => onPostProcess(data, educationGoal)}
      validatedOnClick={() =>
        workflowAnalyticsEvents(workflowId, 'education_specific_college_completed')
      }
    />
  </AdvWorkflowStep>
);

IsSpecificSchoolView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store: PropTypes.func.isRequired,
  educationGoal: PropTypes.shape({
    IsSpecificCollege: PropTypes.bool,
  }).isRequired,
  onPostProcess: PropTypes.func.isRequired,
  nextIterators: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
};

export default IsSpecificSchoolView;
